import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';

// Note: FE library tracking is generally done by passing the tracker instance
// from the parent app to the library. However, this is obnoxiously complicated:
// https://product.hubteam.com/docs/usage-tracking-manual/docs/frontend/library-tracking.html
// Let's do it the easy way for now.
const usageTracker = createTracker({
  events
});
export default usageTracker;